import { render, staticRenderFns } from "./TransferDana.vue?vue&type=template&id=bcc8bbe2"
import script from "./TransferDana.vue?vue&type=script&lang=js"
export * from "./TransferDana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports